/** * @description: 年报服务--合同登记 * @param {*} * @return {*} */
<template>
  <!-- ContractSearch   userInfo-->
  <div class="user-management-container">
    <tabel-panel
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="ContractSearch"
      :condition="conditionData"
      editType="pop"
      :autoSearch="true"
      :showCancelButton="false"
      @popConfirmButtonClick="popConfirmButtonClick"
      :clickRowSelected="false"
      @customerRowDblClick="customerRowDblClick"
      :popToCustomer="true"
    >
      <template v-slot:tabelTitleLeft>
        <div>合同登记</div>
      </template>
      <template v-slot:tabelTitleRight>
        <add-button @buttonClick="addList"> 添加 </add-button>
      </template>
      <template v-slot:condition style="height: 200px">
        <text-field
          v-model:value="conditionData.cid"
          labelText="客户:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguName"
          class="condition-container-input"
        >
        </text-field>
        <!-- <text-field v-model:value="conditionData.did" labelText="维保服务类型:" :clearable="true" type="select"
          :selectRemoteSearchData="selectWeiBaoName" class="condition-container-input">
        </text-field> -->
        <text-field
          v-model:value="conditionData.did"
          labelText="维保服务类型:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectWeiBaoNameType"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.con"
          labelText="合同编号:"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.buyDate"
          type="date"
          labelText="购买日期:"
          clearable
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.endDate"
          type="date"
          labelText="截至日期:"
          clearable
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.sn"
          labelText="SN号:"
          class="condition-container-input"
        >
        </text-field>
      </template>

      <template v-slot:snBtn="$opData">
        <div class="opration">
          <div class="style-aaa" @click="handSN($opData.data.row)">sn</div>
          <!-- <control-button class="item" @buttonClick="handSN($opData.data.row)">
            SN
          </control-button> -->
        </div>
      </template>

      <template v-slot:repairBtn="$opData">
        <div class="style-aaa" @click="openImg($opData.data.row)">打开</div>
        <div class="opration">
          <!-- <control-button class="item" @buttonClick="openImg($opData.data.row)">
            打开
          </control-button> -->
        </div>
      </template>

      <template v-slot:goBackBtn="$opData">
        <div class="opration">
          <div class="style-aaa" @click="delSingleUser($opData.data.row)">
            删除
          </div>
          <!-- <del-border
            class="item"
            :useConfirm="true"
            comfirmMessage="确定删除吗？"
            comfirmOkText="确定"
            comfirmCancelText="取消"
            @buttonClick="delSingleUser($opData.data.row)"
          >
          </del-border> -->
        </div>
      </template>
    </tabel-panel>

    <el-dialog
      v-model="centerDialogVisible"
      width="90%"
      top="5vh"
      :show-close="false"
      style="
         {
          height: '90%';
        }
      "
      center
    >
      <div class="img-dialog-container">
        <iframe
          :src="imgSrc + '#view=FitH,top'"
          style="width: 100%; height: 100%"
          class="img-iframe"
        ></iframe>
        <img style="width: 100%" :src="imgSrc" v-if="false" />
      </div>
    </el-dialog>

    <!-- 添加合同 -->
    <pop-dialog
      v-if="addDialog"
      ref="editBox"
      :showButtons="false"
      :boxMaxWidth="true"
      @dialogClose="addDialog = false"
    >
      <template v-slot>
        <div class="dialogBox">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-row>
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-form-item label="客户:" prop="CompanyId">
                    <el-select
                      v-model="ruleForm.CompanyId"
                      placeholder="请选择"
                      filterable
                      size="small"
                    >
                      <el-option
                        v-for="(item, index) in CompanyIdData"
                        :key="index"
                        :label="item.CompName"
                        :value="item.Company_Id"
                      >
                        {{ item.CompName }}
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <!-- 原厂类型 -->
              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <!-- 供应商类型 -->
                  <!-- 原厂类型 -->
                  <el-form-item
                    label="供应商服务类型:"
                    label-width="110px"
                    prop="DicInfoId"
                  >
                    <el-select
                      v-model="ruleForm.DicInfoId"
                      placeholder="请选择活动区域"
                      clearable
                      size="small"
                    >
                      <el-option
                        v-for="(item, index) in selectDataDicInfoId"
                        :key="index"
                        :label="item.Name"
                        :value="item.Id"
                      >
                      </el-option>
                    </el-select>
                    <el-date-picker
                      type="date"
                      placeholder="开始日期"
                      v-model="ruleForm.BuyDate"
                      size="small"
                      style="width: 100%"
                      @change="getBirthTime($event, 'BuyDate')"
                    >
                    </el-date-picker>
                    <el-date-picker
                      type="date"
                      placeholder="结束日期"
                      v-model="ruleForm.EndDate"
                      size="small"
                      style="width: 100%"
                      @change="getBirthTime($event, 'EndDate')"
                    >
                    </el-date-picker>
                    <el-date-picker
                      type="date"
                      placeholder="提醒日期"
                      v-model="ruleForm.rimDate"
                      size="small"
                      style="width: 100%"
                      @change="getBirthTime($event, 'rimDate')"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
              <!-- 供应商服务类型 -->
              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <!-- 供应商类型 -->
                  <!-- 原厂类型 -->
                  <el-form-item label="原厂服务类型:" prop="DicInfoIdY">
                    <el-select
                      v-model="ruleForm.DicInfoIdY"
                      placeholder="请选择活动区域"
                      clearable
                      size="small"
                    >
                      <el-option
                        v-for="(item, index) in selectDataDicInfoIdY"
                        :key="index"
                        :label="item.Name"
                        :value="item.Id"
                      >
                      </el-option>
                    </el-select>
                    <el-date-picker
                      type="date"
                      placeholder="开始日期"
                      v-model="ruleForm.BuyDateY"
                      size="small"
                      style="width: 100%"
                      @change="getBirthTime($event, 'BuyDateY')"
                    >
                    </el-date-picker>
                    <el-date-picker
                      type="date"
                      placeholder="结束日期"
                      v-model="ruleForm.EndDateY"
                      size="small"
                      style="width: 100%"
                      @change="getBirthTime($event, 'EndDateY')"
                    >
                    </el-date-picker>
                    <el-date-picker
                      type="date"
                      placeholder="提醒日期"
                      v-model="ruleForm.rimDateY"
                      size="small"
                      style="width: 100%"
                      @change="getBirthTime($event, 'rimDateY')"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-form-item label="合同编号:" prop="ContractNo">
                    <el-input
                      v-model="ruleForm.ContractNo"
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="月限:" prop="Month">
                    <el-input
                      v-model.number="ruleForm.Month"
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="周期:" prop="cycle">
                    <el-input
                      v-model.number="ruleForm.cycle"
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <!-- <el-form-item label="周期:" prop="cycle">
                      <el-input v-model.number="ruleForm.cycle" size="small"></el-input>
                      </el-form-item> rules fileListPNG -->
                </div>
              </el-col>
              <!-- 图片修改为附件 -->
              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <span
                    style="
                      color: red;
                      float: left;
                      line-height: 33px;
                      position: relative;
                      right: -60px;
                    "
                    >*</span
                  >
                  <el-form-item label="附件:" prop="fileListPNG">
                    <el-upload
                      class="upload-demo"
                      ref="upload"
                      multiple
                      :limit="20"
                      action="#"
                      accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
                      :on-change="handleChange"
                      :before-upload="handleBefore"
                      :on-remove="handleRemovePNG"
                      :file-list="uploadParam.fileListPNG"
                      :auto-upload="false"
                    >
                      <template #trigger>
                        <el-button size="small" style="padding: 6px 10px"
                          >选取附件</el-button
                        >
                      </template>
                      <el-button
                        style="margin-left: 10px; display: none"
                        size="small"
                        type="success"
                      ></el-button>
                      <template #tip> </template>
                    </el-upload>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="合同设备">
                    <el-upload
                      class="upload-demo"
                      ref="upload3"
                      multiple
                      :limit="20"
                      action="#"
                      accept=" .doc, .docx, .xls, .xlsx"
                      :on-change="handleChange2"
                      :before-upload="handleBefore"
                      :on-remove="handleRemove"
                      :file-list="fileList"
                      :auto-upload="false"
                    >
                      <template #trigger>
                        <el-button size="small" style="padding: 6px 10px"
                          >选取文件</el-button
                        >
                      </template>
                      <el-button
                        style="margin-left: 10px; display: none"
                        size="small"
                        type="success"
                      ></el-button>
                      <template #tip> </template>
                    </el-upload>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-form-item label="服务公司:" prop="companyArray">
                <el-checkbox-group
                  v-model="ruleForm.companyArray"
                  v-for="(item, index) in CompanyIdDataShooin"
                  :key="index"
                >
                  <el-checkbox
                    :label="item.Company_Id"
                    :key="item.Company_Id"
                    >{{ item.CompName }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-row>

            <el-row>
              <el-col :span="14">
                <el-form-item label="备注:" prop="Appendix">
                  <el-input
                    type="textarea"
                    v-model="ruleForm.Appendix"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="7">
                <el-form-item label="不递送:" prop="notExpress">
                  <el-checkbox
                    v-model="ruleForm.notExpress"
                    label="uploadFile"
                    >{{ ruleForm.notExpress === true ? " " : " " }}</el-checkbox
                  >
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="品牌名称:" prop="BrandID">
                    <el-input
                      :readonly="true"
                      v-model="producionType.pinP"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="产品类型:" prop="ProductID">
                    <el-input
                      :readonly="true"
                      v-model="producionType.pro"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="产品型号:" prop="mid">
                    <el-select
                      v-model="ruleForm.mid"
                      @change="handleSerach"
                      filterable
                      remote
                      placeholder="请输入关键词"
                      :remote-method="remoteMethod"
                      :loading="loading"
                    >
                      <el-option
                        v-for="item in remoteMethodOptions"
                        :key="item.id"
                        :label="item.ModelNoStr"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="15">
                <el-form-item label="SN:" prop="sn">
                  <el-input type="textarea" v-model="ruleForm.sn"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="4">
                <div class="grid-content bg-purple"></div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple-light"></div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple">
                  <add-button @click="submitForm('ruleForm')">保存</add-button>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple-light">
                  <control-button @click="resetForm('ruleForm')"
                    >重置</control-button
                  >
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple"></div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple-light"></div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </template>
    </pop-dialog>

    <el-dialog
      v-model="addDialogClose"
      width="80%"
      append-to-body
      title="添加合同"
      center
    >
      <div class="dialogBox">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-row>
            <el-col :span="7">
              <div class="grid-content bg-purple">
                <el-form-item label="客户:" prop="CompanyId">
                  <el-select
                    v-model="ruleForm.CompanyId"
                    placeholder="请选择"
                    filterable
                    size="small"
                  >
                    <el-option
                      v-for="(item, index) in CompanyIdData"
                      :key="index"
                      :label="item.CompName"
                      :value="item.Company_Id"
                    >
                      {{ item.CompName }}
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <!-- 原厂类型 -->
            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <!-- 供应商类型 -->
                <!-- 原厂类型 -->
                <el-form-item
                  label="供应商服务类型:"
                  label-width="110px"
                  prop="DicInfoId"
                >
                  <el-select
                    v-model="ruleForm.DicInfoId"
                    placeholder="请选择活动区域"
                    clearable
                    size="small"
                  >
                    <el-option
                      v-for="(item, index) in selectDataDicInfoId"
                      :key="index"
                      :label="item.Name"
                      :value="item.Id"
                    >
                    </el-option>
                  </el-select>
                  <el-date-picker
                    type="date"
                    placeholder="开始日期"
                    v-model="ruleForm.BuyDate"
                    size="small"
                    style="width: 100%"
                    @change="getBirthTime($event, 'BuyDate')"
                  >
                  </el-date-picker>
                  <el-date-picker
                    type="date"
                    placeholder="结束日期"
                    v-model="ruleForm.EndDate"
                    size="small"
                    style="width: 100%"
                    @change="getBirthTime($event, 'EndDate')"
                  >
                  </el-date-picker>
                  <el-date-picker
                    type="date"
                    placeholder="提醒日期"
                    v-model="ruleForm.rimDate"
                    size="small"
                    style="width: 100%"
                    @change="getBirthTime($event, 'rimDate')"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </el-col>
            <!-- 供应商服务类型 -->
            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <!-- 供应商类型 -->
                <!-- 原厂类型 -->
                <el-form-item label="原厂服务类型:" prop="DicInfoIdY">
                  <el-select
                    v-model="ruleForm.DicInfoIdY"
                    placeholder="请选择活动区域"
                    clearable
                    size="small"
                  >
                    <el-option
                      v-for="(item, index) in selectDataDicInfoIdY"
                      :key="index"
                      :label="item.Name"
                      :value="item.Id"
                    >
                    </el-option>
                  </el-select>
                  <el-date-picker
                    type="date"
                    placeholder="开始日期"
                    v-model="ruleForm.BuyDateY"
                    size="small"
                    style="width: 100%"
                    @change="getBirthTime($event, 'BuyDateY')"
                  >
                  </el-date-picker>
                  <el-date-picker
                    type="date"
                    placeholder="结束日期"
                    v-model="ruleForm.EndDateY"
                    size="small"
                    style="width: 100%"
                    @change="getBirthTime($event, 'EndDateY')"
                  >
                  </el-date-picker>
                  <el-date-picker
                    type="date"
                    placeholder="提醒日期"
                    v-model="ruleForm.rimDateY"
                    size="small"
                    style="width: 100%"
                    @change="getBirthTime($event, 'rimDateY')"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="7">
              <div class="grid-content bg-purple">
                <el-form-item label="合同编号:" prop="ContractNo">
                  <el-input
                    v-model="ruleForm.ContractNo"
                    size="small"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <el-form-item label="月限:" prop="Month">
                  <el-input
                    v-model.number="ruleForm.Month"
                    size="small"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <el-form-item label="周期:" prop="cycle">
                  <el-input
                    v-model.number="ruleForm.cycle"
                    size="small"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <!-- <el-form-item label="周期:" prop="cycle">
								<el-input v-model.number="ruleForm.cycle" size="small"></el-input>
								</el-form-item> rules fileListPNG -->
              </div>
            </el-col>
            <!-- 图片修改为附件 -->
            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <span
                  style="
                    color: red;
                    float: left;
                    line-height: 33px;
                    position: relative;
                    right: -60px;
                  "
                  >*</span
                >
                <el-form-item label="附件:" prop="fileListPNG">
                  <el-upload
                    class="upload-demo"
                    ref="upload"
                    multiple
                    :limit="20"
                    action="#"
                    accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
                    :on-change="handleChange"
                    :before-upload="handleBefore"
                    :on-remove="handleRemovePNG"
                    :file-list="uploadParam.fileListPNG"
                    :auto-upload="false"
                  >
                    <template #trigger>
                      <el-button size="small" style="padding: 6px 10px"
                        >选取附件</el-button
                      >
                    </template>
                    <el-button
                      style="margin-left: 10px; display: none"
                      size="small"
                      type="success"
                    ></el-button>
                    <template #tip> </template>
                  </el-upload>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <el-form-item label="合同设备">
                  <el-upload
                    class="upload-demo"
                    ref="upload3"
                    multiple
                    :limit="20"
                    action="#"
                    accept=" .doc, .docx, .xls, .xlsx"
                    :on-change="handleChange2"
                    :before-upload="handleBefore"
                    :on-remove="handleRemove"
                    :file-list="fileList"
                    :auto-upload="false"
                  >
                    <template #trigger>
                      <el-button size="small">选取文件</el-button>
                    </template>
                    <el-button
                      style="margin-left: 10px; display: none"
                      size="small"
                      type="success"
                    ></el-button>
                    <template #tip> </template>
                  </el-upload>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-form-item label="服务公司:" prop="companyArray">
              <el-checkbox-group
                v-model="ruleForm.companyArray"
                v-for="(item, index) in CompanyIdDataShooin"
                :key="index"
              >
                <el-checkbox :label="item.Company_Id" :key="item.Company_Id">{{
                  item.CompName
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-row>

          <el-row>
            <el-col :span="14">
              <el-form-item label="备注:" prop="Appendix">
                <el-input
                  type="textarea"
                  v-model="ruleForm.Appendix"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item label="不递送:" prop="notExpress">
                <el-checkbox v-model="ruleForm.notExpress" label="uploadFile">{{
                  ruleForm.notExpress === true ? " " : " "
                }}</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <el-form-item label="品牌名称:" prop="BrandID">
                  <el-input
                    :readonly="true"
                    v-model="producionType.pinP"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <el-form-item label="产品类型:" prop="ProductID">
                  <el-input
                    :readonly="true"
                    v-model="producionType.pro"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <el-form-item label="产品型号:" prop="mid">
                  <el-select
                    v-model="ruleForm.mid"
                    @change="handleSerach"
                    filterable
                    remote
                    placeholder="请输入关键词"
                    :remote-method="remoteMethod"
                    :loading="loading"
                  >
                    <el-option
                      v-for="item in remoteMethodOptions"
                      :key="item.id"
                      :label="item.ModelNoStr"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="15">
              <el-form-item label="SN:" prop="sn">
                <el-input type="textarea" v-model="ruleForm.sn"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="4">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple">
                <add-button @click="submitForm('ruleForm')">保存</add-button>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple-light">
                <control-button @click="resetForm('ruleForm')"
                  >重置</control-button
                >
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>

    <!-- 双击展示模块 -->
    <pop-dialog
      v-if="editListDialog"
      ref="editBox"
      :showButtons="false"
      :boxMaxWidth="true"
      @dialogClose="editListDialog = false"
    >
      <template v-slot>
        <div class="dialogBox">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="editForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-row>
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-form-item label="客户:" prop="CompanyId">
                    <el-select
                      v-model="ruleForm.CompanyId"
                      placeholder="请选择"
                      size="small"
                    >
                      <el-option
                        v-for="(item, index) in CompanyIdData"
                        :key="index"
                        :label="item.CompName"
                        :value="item.Company_Id"
                      >
                        {{ item.CompName }}
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-form-item
                    label="维保服务类型:"
                    prop="DicInfoId"
                    v-if="YOrGonflag == 'supplier'"
                  >
                    <el-select v-model="ruleForm.DicInfoId" size="small">
                      <el-option
                        v-for="(item, index) in selectDataDicInfoId"
                        :key="index"
                        :label="item.Name"
                        :value="item.Id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="原厂服务类型:" prop="DicInfoIdY" v-else>
                    <!-- 原厂 -->
                    <el-select v-model="ruleForm.DicInfoIdY" size="small">
                      <el-option
                        v-for="(item, index) in selectDataDicInfoIdY"
                        :key="index"
                        :label="item.Name"
                        :value="item.Id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-form-item label="合同编号:" prop="ContractNo">
                    <el-input
                      v-model="ruleForm.ContractNo"
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <!-- 日期 -->
              <el-col :span="7">
                <el-form-item label="购买日期:" prop="BuyDate">
                  <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    v-model="ruleForm.BuyDate"
                    size="small"
                    style="width: 100%"
                    @change="getBirthTime($event, 'BuyDate')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="截至日期:" prop="EndDate">
                    <el-date-picker
                      type="date"
                      placeholder="选择日期"
                      v-model="ruleForm.EndDate"
                      size="small"
                      style="width: 100%"
                      @change="getBirthTime($event, 'EndDate')"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <!-- <el-form-item label="提醒日期:" prop="rimDate">
                        <el-date-picker type="date" placeholder="选择日期"
                          v-model="ruleForm.rimDate" size="small" style="width: 100%;"
                          @change="getBirthTime($event, 'rimDate')">
                        </el-date-picker>
                      </el-form-item> -->
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="月限:" prop="Month">
                    <el-input
                      v-model.number="ruleForm.Month"
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="周期:" prop="cycle">
                    <el-input
                      v-model.number="ruleForm.cycle"
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <span
                    style="
                      color: red;
                      float: left;
                      line-height: 33px;
                      position: relative;
                      right: -60px;
                    "
                    >*</span
                  >
                  <el-form-item label="附件:" prop="fileListPNG">
                    <!-- 修改附件 >> 数量待定 -->
                    <el-upload
                      class="upload-demo"
                      ref="upload"
                      :limit="1"
                      action="#"
                      accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.xlsx,.xls,.word,.WORD"
                      :on-change="handleChange"
                      :on-preview="handlePreview"
                      :before-upload="handleBefore"
                      :on-remove="handleRemovePNG"
                      :file-list="uploadParam.fileListPNG"
                      :auto-upload="false"
                    >
                      <template #trigger>
                        <el-button size="small" style="padding: 6px 10px"
                          >选取附件</el-button
                        >
                      </template>
                      <el-button
                        style="margin-left: 10px; display: none"
                        size="small"
                        type="success"
                        @click="submitUpload"
                        >上传到服务器</el-button
                      >
                      <template #tip>
                        <div class="el-upload__tip"></div>
                      </template>
                    </el-upload>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="服务公司:" prop="companyArray">
                <el-checkbox-group
                  v-model="ruleForm.companyArray"
                  :key="index"
                  v-for="(item, index) in CompanyIdDataShooin"
                >
                  <el-checkbox
                    :label="item.Company_Id"
                    :key="item.Company_Id"
                    >{{ item.CompName }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-row>

            <el-row>
              <el-col :span="15">
                <el-form-item label="备注:" prop="Appendix">
                  <el-input
                    type="textarea"
                    v-model="ruleForm.Appendix"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <div class="grid-content bg-purple"></div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <add-button @click="editForm('editForm')">保存</add-button>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple-light"></div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </template>
    </pop-dialog>

    <!-- 双击展示文件编辑 -->
    <el-dialog v-model="editListDialogClose" width="80%" center>
      <div class="dialogBox">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="editForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-row>
            <el-col :span="7">
              <div class="grid-content bg-purple">
                <el-form-item label="客户:" prop="CompanyId">
                  <el-select
                    v-model="ruleForm.CompanyId"
                    placeholder="请选择"
                    size="small"
                  >
                    <el-option
                      v-for="(item, index) in CompanyIdData"
                      :key="index"
                      :label="item.CompName"
                      :value="item.Company_Id"
                    >
                      {{ item.CompName }}
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <el-form-item
                  label="维保服务类型:"
                  prop="DicInfoId"
                  v-if="YOrGonflag == 'supplier'"
                >
                  <el-select v-model="ruleForm.DicInfoId" size="small">
                    <el-option
                      v-for="(item, index) in selectDataDicInfoId"
                      :key="index"
                      :label="item.Name"
                      :value="item.Id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="维保服务类型:" prop="DicInfoIdY" v-else>
                  <!-- 原厂 -->
                  <el-select v-model="ruleForm.DicInfoIdY" size="small">
                    <el-option
                      v-for="(item, index) in selectDataDicInfoIdY"
                      :key="index"
                      :label="item.Name"
                      :value="item.Id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="7">
              <div class="grid-content bg-purple">
                <el-form-item label="合同编号:" prop="ContractNo">
                  <el-input
                    v-model="ruleForm.ContractNo"
                    size="small"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
            <!-- 日期 -->
            <el-col :span="7">
              <el-form-item label="购买日期:" prop="BuyDate">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="ruleForm.BuyDate"
                  size="small"
                  style="width: 100%"
                  @change="getBirthTime($event, 'BuyDate')"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <el-form-item label="截至日期:" prop="EndDate">
                  <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    v-model="ruleForm.EndDate"
                    size="small"
                    style="width: 100%"
                    @change="getBirthTime($event, 'EndDate')"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <!-- <el-form-item label="提醒日期:" prop="rimDate">
									<el-date-picker type="date" placeholder="选择日期"
										v-model="ruleForm.rimDate" size="small" style="width: 100%;"
										@change="getBirthTime($event, 'rimDate')">
									</el-date-picker>
								</el-form-item> -->
              </div>
            </el-col>

            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <el-form-item label="月限:" prop="Month">
                  <el-input
                    v-model.number="ruleForm.Month"
                    size="small"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <el-form-item label="周期:" prop="cycle">
                  <el-input
                    v-model.number="ruleForm.cycle"
                    size="small"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="7">
              <div class="grid-content bg-purple-light">
                <span
                  style="
                    color: red;
                    float: left;
                    line-height: 33px;
                    position: relative;
                    right: -60px;
                  "
                  >*</span
                >
                <el-form-item label="附件:" prop="fileListPNG">
                  <!-- 修改附件 >> 数量待定 -->
                  <el-upload
                    class="upload-demo"
                    ref="upload"
                    :limit="1"
                    action="#"
                    accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.xlsx,.xls,.word,.WORD"
                    :on-change="handleChange"
                    :on-preview="handlePreview"
                    :before-upload="handleBefore"
                    :on-remove="handleRemovePNG"
                    :file-list="uploadParam.fileListPNG"
                    :auto-upload="false"
                  >
                    <template #trigger>
                      <el-button size="small" style="padding: 6px 10px"
                        >选取附件</el-button
                      >
                    </template>
                    <el-button
                      style="margin-left: 10px; display: none"
                      size="small"
                      type="success"
                      @click="submitUpload"
                      >上传到服务器</el-button
                    >
                    <template #tip>
                      <div class="el-upload__tip"></div>
                    </template>
                  </el-upload>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="服务公司:" prop="companyArray">
              <el-checkbox-group
                v-model="ruleForm.companyArray"
                :key="index"
                v-for="(item, index) in CompanyIdDataShooin"
              >
                <el-checkbox :label="item.Company_Id" :key="item.Company_Id">{{
                  item.CompName
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-row>

          <el-row>
            <el-col :span="15">
              <el-form-item label="备注:" prop="Appendix">
                <el-input
                  type="textarea"
                  v-model="ruleForm.Appendix"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <add-button @click="editForm('editForm')">保存</add-button>
              </div>
            </el-col>

            <el-col :span="8">
              <div class="grid-content bg-purple-light"></div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>

    <!-- SNSearch列表sn vContractSearch-->
    <!-- // 点击sn>>> -->
    <!-- <el-dialog v-model="SNDialog" width="100%" title="SN信息" :center="false">
      <div id="SNDialog" class="dialogBox">
        <div>
          <tabel-panel ref="tabelSNlist" style="height: 350px;" :rowTemplate="SNrowTemplate" api="SNSearch"
            :condition="SNData" editType="pop" :autoSearch="true" :showCancelButton="false" :clickRowSelected="false"
            @customerRowDblClick="snRowClick" :popToCustomer="true">
            <template v-slot:tabelTitleLeft>
              <div>SN列表</div>
            </template>
            <template v-slot:tabelTitleRight>
              <add-button @buttonClick="addTabelSN">
                添加
              </add-button>

              <add-button @buttonClick="exportAlls" class="SN-TabelTitleRight-btn">
                导出
              </add-button>
            </template>

            <template v-slot:condition style="height: 200px;">

              <text-field v-model:value="SNData.CusCopmany" 
                labelText="公司名称:" 
                ref="selectCusCopmany"
                :clearable="true" 
                type="select"
                :selectRemoteSearchData="selectOuguName" 
                class="condition-container-input">
              </text-field>
              <text-field
                v-model:value="SNData.BrandId"
                labelText="品牌名称:"
                ref="selectBrandId"
                :clearable="true"
                type="select"
                :selectRemoteSearchData="selectOuguBrand"
                class="condition-container-input"
              >
              </text-field>

              <text-field
                v-model:value="SNData.ProductId"
                labelText="产品类别:"
                ref="selectChild"
                :clearable="true"
                :type="selectChildData == null ? 'select' : 'selectChild'"
                :selectChildData="selectChildData"
                :selectRemoteSearchData="selectOuguNameProduct"
                class="condition-container-input"
              >
              </text-field>

              <text-field
                v-model:value="SNData.MondelId"
                labelText="产品型号:"
                ref="selectChildMoid"
                :clearable="true"
                :type="selectChildData == null ? 'select' : 'selectChild'"
                :selectChildData="selectChildMoid"
                :selectRemoteSearchData="selectOuguNameModelSelect"
                class="condition-container-input"
              >
              </text-field>

              <text-field v-model:value="SNData.SN" labelText="SN号:" class="condition-container-input">
              </text-field>
            </template>
            <template v-slot:goBackBtn="$opData">
              <div class="opration">
                <del-button class="item" :useConfirm="true" comfirmMessage="确定删除吗？" comfirmOkText="确定"
                  comfirmCancelText="取消" @buttonClick="delTabelSN($opData.data.row)">
                  删除
                </del-button>
              </div>
            </template>
          </tabel-panel>
        </div>
      </div>
    </el-dialog> -->

    <!-- 列表sn -->
    <pop-dialog
      v-if="SNDialog"
      ref="editBox"
      :showButtons="false"
      :boxMaxWidth="true"
      @dialogClose="SNDialog = false"
    >
      <template v-slot>
        <!-- <div id="SNDialog" class="dialogBox"> -->
        <tabel-panel
          ref="tabelSNlist"
          style="height: 350px; overflow: hidden"
          :rowTemplate="SNrowTemplate"
          api="SNSearch"
          :condition="SNData"
          editType="pop"
          :autoSearch="true"
          :showCancelButton="false"
          :clickRowSelected="false"
          :popToCustomer="true"
        >
          <template v-slot:tabelTitleLeft>
            <div>SN列表</div>
          </template>
          <template v-slot:tabelTitleRight>
            <add-button @buttonClick="addTabelSN"> 添加 </add-button>

            <add-button
              @buttonClick="exportAlls"
              class="SN-TabelTitleRight-btn"
            >
              导出
            </add-button>
          </template>

          <template v-slot:condition style="height: 200px">
            <text-field
              v-model:value="SNData.CusCopmany"
              labelText="公司名称:"
              ref="selectCusCopmany"
              :clearable="true"
              type="select"
              :selectRemoteSearchData="selectOuguName"
              class="condition-container-input"
            >
            </text-field>
            <text-field
              v-model:value="SNData.BrandId"
              labelText="品牌名称:"
              ref="selectBrandId"
              :clearable="true"
              type="select"
              :selectRemoteSearchData="selectOuguBrand"
              class="condition-container-input"
            >
            </text-field>

            <text-field
              v-model:value="SNData.ProductId"
              labelText="产品类别:"
              ref="selectChild"
              :clearable="true"
              :type="selectChildData == null ? 'select' : 'selectChild'"
              :selectChildData="selectChildData"
              :selectRemoteSearchData="selectOuguNameProduct"
              class="condition-container-input"
            >
            </text-field>

            <text-field
              v-model:value="SNData.MondelId"
              labelText="产品型号:"
              ref="selectChildMoid"
              :clearable="true"
              :type="selectChildData == null ? 'select' : 'selectChild'"
              :selectChildData="selectChildMoid"
              :selectRemoteSearchData="selectOuguNameModelSelect"
              class="condition-container-input"
            >
            </text-field>

            <text-field
              v-model:value="SNData.SN"
              labelText="SN号:"
              class="condition-container-input"
            >
            </text-field>
          </template>
          <template v-slot:goBackBtn="$opData">
            <div class="opration">
              <del-button
                class="item"
                :useConfirm="true"
                comfirmMessage="确定删除吗？"
                comfirmOkText="确定"
                comfirmCancelText="取消"
                @buttonClick="delTabelSN($opData.data.row)"
              >
                删除
              </del-button>
            </div>
          </template>
        </tabel-panel>
        <!-- </div> -->
      </template>
    </pop-dialog>
    <popDialogDrag style="display: none" v-if="SNDialog"> </popDialogDrag>

    <!-- 添加SN -->
    <pop-dialog
      v-if="TabelSN"
      ref="editBoxSN"
      :showButtons="false"
      :boxMaxWidth="true"
      @dialogClose="TabelSN = false"
    >
      <template v-slot>
        <div class="dialogBox">
          <el-form
            :model="snAdd"
            :rules="rulesSN"
            ref="snForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-row v-if="!snListDataIs">
              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="公司名称:" prop="compid">
                    <el-select
                      v-model="snAdd.compid"
                      clearable
                      placeholder="请选择"
                      filterable
                      required
                      size="small"
                    >
                      <el-option
                        v-for="item in CompanyInfoSliect"
                        :key="item.Company_Id"
                        :label="item.CompName"
                        :value="item.Company_Id"
                        style="padding-left: 10px"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="品牌名称:" prop="BrandID">
                    <!-- <el-select
                      v-model="snAdd.BrandID"
                      clearable
                      placeholder="请选择"
                      @change="addProductSelect"
                      filterable
                      required
                      size="small"
                    >
                      <el-option
                        v-for="item in BrandData"
                        :key="item.id"
                        :label="item.Name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>  snAdd.ProductID snAdd.BrandID-->

                    <el-input
                      :readonly="true"
                      v-model="snAdd.BrandID"
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="产品类型:" prop="ProductID">
                    <!-- <el-select
                      v-model="snAdd.ProductID"
                      clearable
                      size="small"
                      placeholder="请选择"
                      @change="addModelSelect"
                    >
                      <el-option
                        v-for="item in ProductData"
                        :key="item.id"
                        :label="item.Name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select> -->
                    <el-input
                      :readonly="true"
                      v-model="snAdd.ProductID"
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-form-item label="产品型号:" prop="ModelNoId">
                    <!-- <el-select
                      v-model="snAdd.ModelNoId"
                      clearable
                      size="small"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in modelData"
                        :key="item.id"
                        :label="item.Name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select> -->

                    <el-select
                      v-model="snAdd.ModelNoId"
                      size="small"
                      @change="handleSerachSN"
                      filterable
                      remote
                      placeholder="请输入关键词"
                      :remote-method="remoteMethod"
                      :loading="loading"
                    >
                      <el-option
                        v-for="item in remoteMethodOptions"
                        :key="item.id"
                        :label="item.ModelNoStr"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-form-item label="合同号:" prop="ContractId">
                    <el-input
                      v-model="snAdd.ContractId"
                      disabled
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-form-item label="系统:" prop="SystemName">
                    <el-input
                      v-model="snAdd.SystemName"
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-form-item label="Fusion版:" prop="Fusion">
                    <el-input v-model="snAdd.Fusion" size="small"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-form-item label="MAC地址:" prop="MACAddr">
                    <el-input v-model="snAdd.MACAddr" size="small"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-form-item label="IP地址:" prop="IPAddr">
                    <el-input v-model="snAdd.IPAddr" size="small"></el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-form-item label="网关掩码DNS:" prop="DNSAddr">
                    <el-input v-model="snAdd.DNSAddr" size="small"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-form-item label="LicenseeName:" prop="Licensee">
                    <el-input v-model="snAdd.Licensee" size="small"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-form-item
                    label="Wavelink注册信息:"
                    label-width="150px"
                    prop="RegeditInfo"
                  >
                    <el-input
                      v-model="snAdd.RegeditInfo"
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <el-form-item label="是否巡检:" prop="State">
                    <el-checkbox v-model="snAdd.State"> </el-checkbox>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="14">
                <el-form-item label="SN:" prop="Name">
                  <el-input type="textarea" v-model="snAdd.Name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="不递送:" prop="NotExpress">
                  <el-checkbox v-model="snAdd.NotExpress"> </el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <div class="grid-content bg-purple"></div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <add-button @click="snSaveForm('snForm')">保存</add-button>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content bg-purple-light"></div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </template>
    </pop-dialog>
  </div>
</template>

<script>
import pdf from "vue-pdf";
import axios from "axios";
import store from "../store/index.js";
import textField from "@/components/textField.vue";
import delBorder from "@/components/delBorder.vue";
import delButton from "@/components/delButton.vue";
import addButton from "@/components/addButton.vue";
import controlButton from "@/components/controlButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import popDialogDrag from "@/components/popDialogDrag.vue";
import tableApi from "@/api/tabel.js";

import { ElMessageBox } from "element-plus";
// import dialogAdd from "@/pages/dialog/contractRegisterAdd.vue";
import {
  ContractDelById,
  CompanyInfoes,
  SNEdit,
  SNDelById,
} from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";
import { downloadExcel } from "@/util/download.js";

export default {
  name: "CusRepairList",
  components: {
    textField,
    addButton,
    delBorder,
    tabelPanel,
    popDialog,
    popDialogDrag,
    delButton,
    controlButton,
    pdf,
  },
  data() {
    return {
      remoteMethodOptions: [], //远程搜索
      producionType: {
        // 类型 型号 品牌 数据显示
        type: null,
        pro: "",
        pinP: "",
        id: "",
      },
      YOrGonflag: null, //控制编辑面板的显示
      TabelSN: false,
      SNDialog2: false,
      pdfData: { zxc: 123 },
      uploadDto: new FormData(),
      fileList: [],
      fileListInspection: [],
      uploadParam: {
        action: "",
        multiple: false,
        limit: 5,
        autoUpoad: false,
        accept: "",
        fileListPNG: [],
      },
      selectDataDicInfoId: null,
      selectDataDicInfoIdY: null,
      BrandData: null,
      ProductData: null,
      modelData: null,
      SNDialog: false,
      addDialog: false,
      editListDialog: false,
      editListDialogClose: false,
      centerDialogVisible: false,
      imgSrc: "",
      checked: false,
      resource: "",
      radio: null,
      inputValue: "明细",
      activeName: "first",
      loadShow: false,
      rowData: null,
      rowTemplate: [
        {
          headerLabel: "客户",
          width: 180,
          editable: true,
          dataIndex: "CompanyName",
        },
        {
          headerLabel: "合同类型",
          width: 140,
          dataIndex: "DicInfoName",
        },
        {
          headerLabel: "合同编号",
          width: 140,
          sortable: true,
          dataIndex: "ContractNo",
        },
        {
          headerLabel: "购买日期",
          width: 120,
          sortable: true,
          dataIndex: "BuyDate",
        },
        {
          headerLabel: "截至日期",
          width: 120,
          sortable: true,
          dataIndex: "EndDate",
        },
        {
          headerLabel: "月限",
          width: "80",
          sortable: true,
          dataIndex: "Month",
        },
        {
          headerLabel: "描述",
          width: 410,
          dataIndex: "Appendix",
        },
        {
          headerLabel: "SN",
          slot: "snBtn",
          width: 100,
        },
        {
          headerLabel: "合同",
          slot: "repairBtn",
          width: 80,
        },
        {
          headerLabel: "删除",
          slot: "goBackBtn",
          width: 100,
        },
      ],
      conditionData: {
        cid: null,
        did: null,
        con: null,
        buyDate: null,
        endDate: null,
        sn: null,
      },
      SNrowTemplate: [
        {
          headerLabel: "公司名称",
          editable: true,
          dataIndex: "CusCopmanyName",
        },
        {
          headerLabel: "SN号",
          editable: true,
          dataIndex: "Name",
        },
        {
          headerLabel: "合同号",
          dataIndex: "ContractName",
        },
        {
          headerLabel: "型号",
          dataIndex: "ModelNoName",
        },
        {
          headerLabel: "是否巡检",
          dataIndex: "State",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
        {
          headerLabel: "删除",
          slot: "goBackBtn",
          width: "120",
        },
      ],
      //sn 查询条件
      SNData: {
        CusCopmany: null,
        Id: null,
        BrandId: null, //BrandId	int	品牌Id
        ProductId: null, //ProductId	int	产品Id
        MondelId: null, //MondelId	int	型号Id
        SN: null,
      },
      snListData: null,
      //公司查询
      CompanyIdData: [],
      CompanyIdDataShooin: [],
      ruleForm: {
        cycle: null, // cycle	Decimal	周期	-
        CompanyId: null, // CompanyId	int	客户Id	是-
        DicInfoId: null, // DicInfoId	int	合同类型id	是
        DicInfoIdY: null, //原厂服务类型
        ContractNo: "", // ContractNo	String	合同号	是
        BuyDate: "", // BuyDate	String	供应商购买日期	是
        EndDate: "", // EndDate	String	供应商截止日期	是
        rimDate: "", // rimDate	String	提醒日期
        BuyDateY: "", //原厂购买开始日期
        EndDateY: "", //原厂结束日期
        rimDateY: "", // rimDate	原厂提醒日期
        Month: null, // Month	Int	月限	是
        Appendix: "", // Appendix	String	备注
        sn: "", // sn	String	SN号	是
        mid: null, // mid	Int	型号Id	是
        companyArray: [], // companyArray	String	服务公司
        notExpress: false, // notExpress	Bool	是否递送
      },
      nullForm: {
        cycle: null, // cycle	Decimal	周期	-
        CompanyId: null, // CompanyId	int	客户Id	是-
        DicInfoId: null, // DicInfoId	int	合同类型id	是
        DicInfoIdY: null, //原厂服务类型
        ContractNo: "", // ContractNo	String	合同号	是
        BuyDate: "", // BuyDate	String	购买日期	是
        EndDate: "", // EndDate	String	截止日期	是
        rimDate: "", // rimDate	String	提醒日期
        Month: null, // Month	Int	月限	是
        Appendix: "", // Appendix	String	备注
        sn: "", // sn	String	SN号	是
        mid: null, // mid	Int	型号Id	是
        companyArray: [], // companyArray	String	服务公司
        notExpress: false, // notExpress	Bool	是否递送
      },

      rules: {
        // age: [
        // 	{ validator: validatePass2, trigger: 'blur' }
        // ],
        // fileListPNG: [
        // 	{ required: true, message: '请选择照片', trigger: "change"},
        // ] ,
        // fileList: [
        // 	{ required: true, message: '请选择文件', trigger:  ["blur", "change"] },
        // ] ,
        rimDate: [{ required: true, message: "请输入", trigger: "blur" }],
        cycle: [
          { required: true, message: "请输入", trigger: "blur" },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        CompanyId: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        DicInfoId: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        DicInfoIdY: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
        ContractNo: [{ required: true, message: "请输入", trigger: "blur" }],
        BuyDate: [{ required: true, message: "请输入", trigger: "blur" }],
        EndDate: [{ required: true, message: "请输入", trigger: "blur" }],
        Month: [{ required: true, message: "请输入", trigger: "blur" }],
        sn: [{ required: true, message: "请输入", trigger: "blur" }],
        mid: [{ required: true, message: "请输入产品型号", trigger: "blur" }],
      },
      rulesSN: {
        BrandID: [{ required: true, message: "请输入", trigger: "blur" }],
        ProductID: [
          { required: true, message: "请输入", trigger: "blur" },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        // ModelNoId: [
        //   { required: true, message: "请输入", trigger: ["blur", "change"] },
        // ],
        Name: [{ required: true, message: "请输入", trigger: "blur" }],
        ModelNoId: [{ required: true, message: "请输入", trigger: "blur" }],
        compid: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      // SN号添加
      snAdd: {
        ModelNoId: null, // ModelNoId	int	型号Id	是
        ContractId: null, // ContractId	int	合同Id	是
        compid: null, // compid	int	公司Id
        NotExpress: false, // NotExpress	Bool	是否递送
        Name: "", // Name	string	SN号	是
        ContractName: "", // ContractName	string	合同号	是
        SystemName: "", // SystemName	string	系统
        Fusion: "", // Fusion	string	Fusion版本
        MACAddr: "", // MACAddr	string	MAC地址
        IPAddr: "", // IPAddr	string	IP地址
        DNSAddr: "", // DNSAddr	string	网关掩码DNS
        Licensee: "", // Licensee	string	LicenseeName
        RegeditInfo: "", // RegeditInfo	string	Wavelink注册信息
        State: false, // State	Bool	是否巡检
      },
      selectChildData: null,
      selectChildMoid: null,
      CompanyInfoSliect: null,
      snListDataIs: false,
    };
  },
  created() {
    this.selectOuguName();
    this.selectWeiBaoName();
    this.selectWeiBaoNameY();
    this.companyAdd();
    this.selectWeiBaoNameType();
  },
  computed: {},
  // 互斥选择>> 合同设备有选文件sn和类型为非必填
  watch: {
    fileList(newV, oldV) {
      if (newV.length > 0) {
        this.rules.sn[0].required = false;
        this.rules.mid[0].required = false;
      } else {
        this.rules.sn[0].required = true;
        this.rules.mid[0].required = true;
      }
    },
    // ruleForm.DicInfoId  ruleForm.DicInfoIdY
    "ruleForm.DicInfoIdY"(newV, oldV) {
      console.log("DicInfoIdY----", newV);
      if (newV) {
        this.rules.DicInfoId[0].required = false;
        this.rules.DicInfoIdY[0].required = true;
      } else {
        this.rules.DicInfoId[0].required = true;
        this.rules.DicInfoIdY[0].required = false;
      }
    },
    "SNData.BrandId"(newV, oldV) {
      this.$refs.selectChild.stringValue = "";
      if (newV) {
        this.selectOuguNameProduct(newV);
        return;
      }
      this.selectChildData = null;
    },
    "SNData.ProductId"(newV, oldV) {
      this.$refs.selectChildMoid.stringValue = "";
      if (newV) {
        this.selectOuguNameModelSelect(newV);
        return;
      }
      this.selectChildMoid = null;
    },
  },
  methods: {
    // 产品型号输入搜索  ----使用防抖
    // 获取到数据之后改变loading 的状态。
    remoteMethod(v) {
      // console.log(tableApi,123)
      tableApi.CompanyInfoTypeRemote({ ModelStr: v + "" }).then((res) => {
        this.remoteMethodOptions = res.data.list || [];
      });
    },
    // 产品型号输入节流发送请求。获取数据。
    handleSerach(id) {
      let value = this.remoteMethodOptions.find(
        (item) => item.id == id
      )?.ModelNoStr;
      const fn = async () => {
        const res = await tableApi.CompanyInfoType({ ModelStr: value + "" });
        if (res.code == 0) {
          this.producionType.pinP = res.data?.list[0]?.BrandName;
          this.producionType.pro = res.data?.list[0]?.ProductName;
          this.producionType.id = res.data?.list[0]?.id;
        }
      };
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        fn();
      }, 1000);
    },
    handleSerachSN(id) {
      let value = this.remoteMethodOptions.find(
        (item) => item.id == id
      )?.ModelNoStr;
      const fn = async () => {
        const res = await tableApi.CompanyInfoType({ ModelStr: value + "" });
        if (res.code == 0) {
          // console.log('sn型号--', res)
          // snAdd.ProductID snAdd.BrandID
          this.snAdd.BrandID = res.data?.list[0]?.BrandName;
          this.snAdd.ProductID = res.data?.list[0]?.ProductName;
          // this.producionType.id = res.data?.list[0]?.id
        }
      };
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        fn();
      }, 1000);
    },
    async selectOuguBrand() {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    async selectOuguNameProduct(Bid) {
      let source;
      if (this.selectChildData == null) {
        source = await tableApi.ProductSelect();
      } else {
        source = await tableApi.ProductSelect({ Bid });
      }
      this.selectChildData = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    async selectOuguNameModelSelect(ProductCategoryId) {
      let source;
      if (this.selectChildMoid == null) {
        source = await tableApi.modelSelect();
      } else {
        source = await tableApi.modelSelect({ ProductCategoryId });
      }
      this.selectChildMoid = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 获取客户数据
    async selectOuguName() {
      let source = await tableApi.CompanyInfo();
      this.CompanyInfoSliect = source.data.list;
      let sourceShooin = await tableApi.CompanyInfoShooin();
      this.CompanyIdData = source.data.list;
      this.CompanyIdDataShooin = sourceShooin.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 供应商维保服务类型
    async selectWeiBaoNameType() {
      let source = await tableApi.WeiBaoFangshiType();
      //  let sourceY = await tableApi.WeiBaoFangshi('original');
      // this.selectDataDicInfoId = source.data.list;
      console.log(source, "AAAA");
      if (source.code == 0) {
        let data = source.data.list.map(({ Type, Name }) => {
          return {
            label: Name,
            value: Type,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 供应商维保服务类型
    async selectWeiBaoName() {
      let source = await tableApi.WeiBaoFangshi({ flag: "supplier" });
      //  let sourceY = await tableApi.WeiBaoFangshi('original');
      this.selectDataDicInfoId = source.data.list;
      console.log(source, "souce");
      if (source.code == 0) {
        let data = source.data.list.map(({ Id, Name }) => {
          return {
            label: Name,
            value: Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 原厂服务类型
    async selectWeiBaoNameY() {
      let sourceY = await tableApi.WeiBaoFangshi({ flag: "original" });
      console.log(sourceY, "sourceY");
      this.selectDataDicInfoIdY = sourceY.data.list;
      //   console.log(sourceY.data.list,'aaaaaaaaaaaaa')
      if (sourceY.code == 0) {
        let data = sourceY.data.list.map(({ Id, Name }) => {
          return {
            label: Name,
            value: Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, sourceY.message);
      }
    },
    // sn之后的事件
    companyAdd() {
      CompanyInfoes().then((data) => {
        if (data.code == 0) {
          this.companyData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
      // 品牌
      tableApi.BrandSelect().then((data) => {
        if (data.code == 0) {
          this.BrandData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 类型
    addProductSelect(v) {
      // let Bid = this.ruleForm.region;
      let Bid = v;
      // console.log(v,Bid,'7777')
      tableApi.ProductSelect({ Bid }).then((data) => {
        if (data.code == 0) {
          this.ProductData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 型号
    addModelSelect(v) {
      // this.ruleForm.region
      let ProductCategoryId = v;
      tableApi.modelSelect({ ProductCategoryId }).then((data) => {
        if (data.code == 0) {
          this.modelData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    delSingleUser(row) {
      // console.log(this.$route,"router")
      // return
      let Id = row.Id;
      console.log("id--", row.Id);
      ElMessageBox.confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ContractDelById({
            Id,
          }).then((data) => {
            if (data.code == 0) {
              successMsg(data.message);
              this.reloadData();
            } else {
              errMsg(data.message);
            }
          });
        })
        .catch(() => {});
    },
    //弹层事件
    popConfirmButtonClick({ slotData }) {
      console.log(slotData);
    },
    // 双击事件 Terminal图片
    customerRowDblClick(row) {
      let listData = row;
      const { YOrGonflag } = row;
      // if (YOrGonflag == "Yuan") {
      //   row.DicInfoIdY = row.DicInfoId;
      // }
      console.log(row, "我是每一行");
      this.ruleForm = listData;
      this.uploadParam.fileListPNG = [listData.Terminal];
      if (this.ruleForm.companyArray == null) {
        this.ruleForm.companyArray = [];
      }
      if (
        this.ruleForm.companyArray != "" &&
        typeof this.ruleForm.companyArray == "string"
      ) {
        this.ruleForm.companyArray = this.ruleForm.companyArray
          .split(",")
          .map((i) => {
            return parseInt(i);
          });
      }

      this.YOrGonflag = YOrGonflag;
      console.log(YOrGonflag, "aaaaaaa");

      this.editListDialog = true;
      this.$nextTick(() => {
        this.$refs.editBox.showPopDialog(null, "编辑信息", true);
      });
    },
    // 添加合同
    addList() {
      this.ruleForm = { companyArray: [] };
      this.addDialog = true;
    },
    // sn 列表
    handSN(row) {
      this.SNDialog = true;
      this.$nextTick(() => {
        this.$refs.editBox.showPopDialog(null, "SN信息", true);
      });
      console.log("sn--", row);
      console.log("this.SNData--", this.SNData);
      // this.SNData.BrandId = ""
      // this.SNData.ProductId = ""
      // this.SNData.MondelId = ""
      this.SNData.SN = "";
      this.SNData.Id = row.Id;
      // SNData
      //根据id查询 sn 列表数据
      this.$nextTick(() => {
        this.$refs.selectCusCopmany.stringValue = "";
        this.$refs.selectBrandId.stringValue = "";
        this.$refs.tabelSNlist.reloadData();
      });
    },
    // sn列表删除
    delTabelSN(row) {
      if (!row.Id) {
        return;
      }
      // let rowData = this.$refs.tabelSNlist.getSelection()
      console.log("delTabelSN--", row);
      // debugger;
      SNDelById({ Id: row.Id }).then((data) => {
        if (data.code == 0) {
          successMsg(data.message);
          this.$refs.tabelSNlist.reloadData();
        } else {
          errMsg(data.message);
        }
      });
    },
    // sn列表添加
    addTabelSN() {
      let snListData = this.$refs.tabelSNlist.getData();
      this.snListDataIs = snListData.every((e) => {
        return snListData[0].CusCopmanyId == e.CusCopmanyId;
      });
      let keys = Object.keys(this.snAdd);
      keys.forEach((i) => {
        this.snAdd[i] = "";
      });
      this.TabelSN = true; //sn点击》》添加》》添加界面visible
      this.snListData = this.$refs.tabelSNlist.getData();
      this.snAdd.ContractId = this.snListData[0].ContractName;

      this.snAdd.State = false;
      this.snAdd.NotExpress = false;

      delete this.snAdd.Id;
    },
    // sn列表编辑
    snRowClick(row) {
      let keys = Object.keys(this.snAdd);
      keys.forEach((i) => {
        this.snAdd[i] = "";
      });
      this.snAdd = row;
      let str = row.ContractId;
      this.snAdd.ContractId = row.ContractName;
      this.snAdd.ContractName = str;
      console.log("snRow--", row);
      this.TabelSN = true;
    },
    // sn添加重置
    snFormReset(row) {
      console.log("snRow--", row);
    },
    // sn添加保存
    snSaveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log("submit--", this.snAdd);
          if (this.snAdd.Id) {
            let params = this.snAdd;
            let str = params.ContractName;
            params.ContractName = params.ContractId;
            params.ContractId = str;
            SNEdit(params).then((data) => {
              if (data.code == 0) {
                successMsg(data.message);
                this.TabelSN = false;
                this.$refs.tabelSNlist.reloadData();
              } else {
                errMsg(data.message);
              }
            });
            return;
          }
          //添加sn 固定参数
          // let { ModelNoId, ContractId, ContractName } = this.snListData[0];
          let { ModelNoId, ContractId, ContractName } =
            this.$refs.tabelSNlist.getData()[0];

          //添加form参数
          // --BrandID: 1
          // --ProductID: 1
          // --compid: null
          let { BrandID, ProductID, ...param } = this.snAdd;
          param.ContractId = ContractId;
          param.ContractName = ContractName;
          if (param.compid == "") {
            param.compid = 0;
          }
          // console.log("submit2--", param);

          SNEdit(param).then((data) => {
            if (data.code == 0) {
              successMsg(data.message);
              this.TabelSN = false;
              this.$refs.tabelSNlist.reloadData();
            } else {
              errMsg(data.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 时间选择改变事件
    getBirthTime(val, name) {
      const newDate =
        val.getFullYear() + "-" + (val.getMonth() + 1) + "-" + val.getDate();
      this.ruleForm[name] = newDate;
    },
    editForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.uploadParam.fileListPNG);
          if (
            this.uploadParam.fileListPNG.length == 0 ||
            this.uploadParam.fileListPNG.length == undefined
          ) {
            return errMsg("请选择图片");
          }
          this.editUpload();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitForm(formName) {
      // 添加图片
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitUpload();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.uploadParam.fileListPNG = [];
      this.fileListInspection = [];
      this.fileList = [];
      this.ruleForm = this.nullForm;

      this.uploadDto.delete("jsonFiles");
      this.uploadDto.delete("photoFiles");
      this.uploadDto.delete("excelFiles1");
      this.uploadDto.delete("excelFiles2");
    },
    //巡检设备
    handleChange3(file, fileList) {
      this.fileListInspection = fileList;
      this.uploadBatch3();
    },
    uploadBatch3() {
      // this.uploadDto = new FormData()
      console.log("this.fileList:", this.fileListInspection);
      this.uploadDto.append("excelFiles2", this.fileListInspection[0].raw);
    },
    // 上传文件
    //合同内设备-------------------
    handleChange2(file, fileList) {
      this.fileList = fileList;
      this.uploadDto.append("excelFiles1", file.raw);
    },

    uploadBatch2() {
      // this.uploadDto = new FormData()
      console.log("this.fileList:", this.fileList);
      // this.uploadDto.append("excelFiles1", this.fileList[0].raw);
    },
    //图片--添加图片上传钩子
    handleChange(file, fileList) {
      this.uploadParam.fileListPNG = fileList;
      // 不能将数组作为遍历 推文件
      this.uploadDto.append("photoFiles", file.raw);
    },
    handleBefore(file) {
      console.log("handleBefore", file);
    },
    // 提交
    submitUpload() {
      const copy = JSON.stringify(this.ruleForm);
      const obj = JSON.parse(copy);
      obj.mid = this.producionType.id;
      let jsonFiles = this.uploadDto.get("jsonFiles");
      console.log(jsonFiles);
      if (jsonFiles == undefined) {
        this.uploadDto.append("jsonFiles", JSON.stringify(obj));
      }
      const formD = () => {
        return axios({
          // 需要修改的
          // url: "http://192.168.1.138:8001/api/Contract/ContractEditdx",
          url: `${migrate_ip}api/Contract/ContractEditdx`,
          headers: {
            "Content-Type": "multipart/form-data",
            token: store.getters.getSessionId,
          },
          method: "post",
          data: this.uploadDto,
        });
      };

      formD().then((data) => {
        if (data.data.code == 0) {
          this.ruleForm = this.nullForm;
          successMsg(data.data.message);
          this.uploadDto.delete("jsonFiles");
          this.uploadDto.delete("photoFiles");
          this.uploadDto.delete("excelFiles1");
          this.uploadDto.delete("excelFiles2");
          this.handleRemovePNG({}, []);
          this.handleRemove({}, []);
          // this.handleRemoveInspection()
          this.addDialog = false;
          this.reloadData();
        } else {
          errMsg(data.data.message);
          this.uploadDto.delete("jsonFiles");
        }
      });
    },
    // 编辑
    editUpload() {
      let jsonFiles = this.uploadDto.get("jsonFiles");
      jsonFiles == undefined;
      if (jsonFiles == undefined) {
        this.uploadDto.append("jsonFiles", JSON.stringify(this.ruleForm));
      }

      console.log("this.uploadDto--", this.uploadDto);
      const formD = () => {
        return axios({
          // 修改
          url: `${migrate_ip}api/Contract/ContractEditdx`,
          headers: {
            "Content-Type": "multipart/form-data",
            token: store.getters.getSessionId,
          },
          method: "post",
          data: this.uploadDto,
        });
      };

      formD().then((data) => {
        if (data.data.code == 0) {
          this.ruleForm = this.nullForm;
          successMsg(data.data.message);
          this.uploadDto.delete("jsonFiles");
          this.uploadDto.delete("photoFiles");
          this.uploadDto.delete("excelFiles1");
          this.uploadDto.delete("excelFiles2");
          // this.handleRemovePNG();
          // this.handleRemove();
          // this.handleRemoveInspection();
          this.editListDialog = false;
          this.reloadData();
        } else {
          errMsg(data.data.message);
          this.ruleForm = this.nullForm;
          this.uploadDto.delete("jsonFiles");
          this.uploadDto.delete("photoFiles");
          this.uploadDto.delete("excelFiles1");
        }
      });
    },
    // 图片附件删除的钩子
    handleRemovePNG(file, fileList) {
      this.uploadDto.delete("photoFiles");
      if (fileList.length > 0) {
        fileList.forEach((item) => {
          this.uploadDto.append("photoFiles", item.raw);
        });
      }

      this.uploadParam.fileListPNG = fileList;
    },
    // 合同删除的钩子
    handleRemove(file, fileList) {
      const res = fileList.map((item) => item.raw);
      this.uploadDto.delete("excelFiles1");
      if (fileList.length > 0) {
        res.forEach((item) => {
          this.uploadDto.append("excelFiles1", item);
        });
      }

      this.fileList = fileList;
    },
    handleRemoveInspection(file, fileList) {
      this.fileListInspection = fileList;
    },
    handlePreview(file) {
      console.log(file);
    },
    openImg(src) {
      console.log(src, "查看合同pdf");

      this.imgSrc = src.Terminal || "../assets/images/contract/482.jpg";
      this.centerDialogVisible = true;
    },
    // 导出
    exportAlls() {
      tableApi
        .SNSearchDao({
          Id: this.SNData.Id,
        })
        .then((data) => {
          downloadExcel(data, "SN号");
        });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

// 更改el-dialog页面视图大小
:deep(.el-dialog--center) {
  height: 90%;
  // :deep(.el-dialog__body){
  //   width:100%;
  //   height:100%;
  // }
}

#suerSwitch .el-switch__core {
  width: 26px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: red;
}

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  // .del {
  //   margin-left: 10px;
  // }

  .condition-container-input {
    width: 270px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        // margin-left: 10px;
      }
    }
  }

  .menuPowerBOX {
    .el-button--default {
      width: 90px;
      height: 30px;
      color: #ffffff;
      background: rgb(100, 134, 232);
      border-radius: 4px;
    }

    .item {
      height: 30px;
      color: #ffffff !important;
      padding: 10px 15px !important;
      background: rgb(100, 134, 232) !important;
    }
  }

  // #loadBOX {
  // 	width: 100%;
  // 	height: 100%;

  // 	.text-field-container {
  // 		display: flex;

  // 	}

  // 	.label-container {
  // 		display: flex;
  // 		width: fit-content;
  // 		height: fit-content;
  // 		padding: 10px;
  // 		box-sizing: border-box;
  // 	}
  // }

  .oprationTree {
    background-color: #ecf5ff;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    padding: 25px 20px 15px 20px;

    .detailed-box {
      width: 100%;
      height: 100%;
      position: relative;
      border: 1px solid #99bce8;
      background-color: #f4f7f6;
      border-radius: 10px;

      .detailed-title {
        font-family: Microsoft YaHei;
        font-weight: normal;
        padding: 10px;
      }

      .text-field-container {
        background: #f4f7f6 !important;
        margin: 10px 20px;
        width: 320px;
      }

      // .user-management-container .condition-container-input {
      //   margin: 5px 10px;
      // }

      .pop-dialogClose {
        position: absolute;
        top: 20px;
        right: 15px;

        .el-icon-close:before {
          font-size: 28px;
        }

        .el-icon-close:hover {
          color: #f92323;
        }
      }
    }
  }

  .pop-dialog-conver {
    width: 100% !important;
    height: 100% !important;
  }

  .control-button-container {
    // margin: 25px auto;
    color: #409eff;
  }

  .SN-TabelTitleRight-btn {
    margin-left: 15px;
    margin-right: 5px;
  }

  .el-radio {
    display: flex;
    width: 300px;
    justify-content: space-evenly;
    flex-direction: row-reverse;
    padding: 20px 20px;
  }

  .el-radio-group {
    width: 100%;
    display: inherit;
    font-family: hanSan !important;
    font-size: 20px;
  }

  .el-checkbox {
    padding-right: 16px;
  }

  .el-select {
    width: 100%;
  }

  .el-upload--picture-card {
    height: 20px !important;
    line-height: 20px !important;
  }
}

.el-form-item {
  margin-bottom: 25px;
}

#SNDialog {
  width: 100%;
  height: 100%;
  margin: 0;
}

::v-deep .el-form-item__content {
  display: flex;
}

::v-deep .el-form-item__content {
  flex-wrap: wrap;
}

.img-dialog-container {
  position: absolute;
  top: 0vh;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;

  .img-iframe {
    width: 100%;
    height: 100%;
  }
}
.style-aaa {
  cursor: pointer;
  color: rgb(100, 134, 232);
  // style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
.snBox {
  position: relative;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 40%;
}
</style>
